/***************************************************************************************
 * FileName      : index.tsx
 * Description   : ketri-portal 진입점 — Portal 컴포넌트를 #content 에 렌더
 * Author        : (주)한국공학기술연구원 박은정
 * Created Date  : 2026.04.27
 ***************************************************************************************/

import * as React from 'react';
import * as ReactDOMClient from 'react-dom/client';

import { Portal } from './Portal';
import './main.css';

const container = document.getElementById('content');
const root = ReactDOMClient.createRoot(container as HTMLElement);
root.render(<Portal />);
